export default function safeWindow(): Window {
  return typeof window === "undefined" ? ({} as Window) : window;
}
